import script from "./UltimateOscillatorIndicator.vue?vue&type=script&lang=js"
export * from "./UltimateOscillatorIndicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__